export default __webpack_public_path__ + "static/media/Lista.750352cb.svg";